import axios from 'axios'
import { SWH_API_ENDPOINT } from 'shared/envs'
import { isomorphicCookies } from 'shared/storage'

const baseURL = SWH_API_ENDPOINT()

const client = axios.create({ baseURL })

client.interceptors.request.use(request => {
  const token = isomorphicCookies.getAll()?.token || ''
  if (token) {
    request.headers.Authorization = `Bearer ${token}`
  }
  return request
})

export const httpClient = client
